import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { InstagramOutlined, FacebookFilled, MenuOutlined, CloseOutlined,TikTokOutlined} from '@ant-design/icons';
import './Navbar.css';
import logoWhite from '../assets/image/logowhite.png';
import logoBlack from '../assets/image/logoblack.png';


const Navbar = () => {


  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navClass = `navbar-container ${!isHome || scrolled ? 'navbar--light' : ''}`;

  const handleNavigate = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <header className={navClass}>
      <div className="navbar-inner">
        <div className="navbar-logo" onClick={() => handleNavigate('/')}>
  <img
  src={isHome && !scrolled ? logoWhite : logoBlack}
  alt="Klyssa Logo"
  className="navbar-logo-img"
/>
</div>

        <nav className={`navbar-links ${mobileOpen ? 'open' : ''} ${isHome && !scrolled ? 'home-style' : 'light-style'}`}>
          <a className="nav-link" onClick={() => handleNavigate('/')}>Home</a>
          <a className="nav-link" onClick={() => handleNavigate('/about')}>About</a>
          <a className="nav-link" onClick={() => handleNavigate('/buyers')}>Buyers</a>
          <a className="nav-link" onClick={() => handleNavigate('/sellers')}>Sellers</a>
          <a className="nav-link" onClick={() => handleNavigate('/clients')}>Clients</a>
        </nav>

        <div className="navbar-socials">
          <a href="https://instagram.com/klyssachong" target="_blank" rel="noreferrer"><InstagramOutlined /></a>
          <a href="https://www.tiktok.com/@klyssachong" target="_blank" rel="noreferrer"><TikTokOutlined /></a>
          <div className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <CloseOutlined style={{ fontSize: '24px', color: isHome ? 'white' : 'black' }}/> : <MenuOutlined style={{ fontSize: '24px', color: isHome ? 'white' : 'black' }} />}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
